// extracted by mini-css-extract-plugin
export var actionButton = "_m3-0";
export var actionMenuContainer = "_m3-i";
export var bubble = "_m3-2";
export var bubbleActionMenu = "_m3-j";
export var bubbleContext = "_m3-6";
export var bubbleItems = "_m3-7";
export var customer = "_m3-3";
export var divider = "_m3-8";
export var fileList = "_m3-9";
export var hiddenComment = "_m3-o";
export var infoAbove = "_m3-a";
export var internal = "_m3-4";
export var lightActionButton = "_m3-1";
export var link = "_m3-b";
export var merchant = "_m3-5";
export var message = "_m3-c";
export var profilePicture = "_m3-e";
export var quillToolbarContainer = "_m3-f";
export var senderDate = "_m3-g";
export var senderDateCustomer = "_m3-h";
export var senderName = "_m3-d";
export var time = "_m3-k";
export var uploadedImage = "_m3-l";
export var username = "_m3-m";
export var xsmall = "_m3-n";